import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 1,
}

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    on: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = 1
    },
    off: (state) => {
      state.value = 0
    },
  },
})

// Action creators are generated for each case reducer function
export const { on, off  } = filterSlice.actions

export default filterSlice.reducer